import { MarcaModel } from './Marca.model';
import { SerieModel } from './Serie.model';
import { AplicacionModel } from './Aplicacion.model';
import { CategoriaModel } from './Categoria.model';
import { TipoProductoModel } from './TipoProducto.model';
import { EventEmitter } from '@angular/core';
import { MultiCheckboxModel } from './multiCheckboxModel';
import { appConstants } from '../constants';
import { CategoriaPrincipalModel } from './CategoriaPrincipal.model';

export class FiltroProductosModel
{
	constructor() { }

	public TextoABuscar: string = "";

	private _aplicacion: AplicacionModel = null;
	public _aplicacionChange: EventEmitter<AplicacionModel> = new EventEmitter();
	public get Aplicacion(): AplicacionModel {
		return this._aplicacion;
	}

	public set Aplicacion(value: AplicacionModel) {
		this._aplicacion = value;
		this._aplicacionChange.emit(this._aplicacion);
	}

	private _categoriaPrincipal: CategoriaPrincipalModel = null;
	public _categoriaPrincipalChange: EventEmitter<CategoriaPrincipalModel> = new EventEmitter();
	public get CategoriaPrincipal(): CategoriaPrincipalModel {
		return this._categoriaPrincipal;
	}

	public set CategoriaPrincipal(value: CategoriaPrincipalModel) {
		this._categoriaPrincipal = value;
		this._categoriaPrincipalChange.emit(this._categoriaPrincipal);
	}

	private _categoria: CategoriaModel = null;
	public _categoriaChange: EventEmitter<CategoriaModel> = new EventEmitter();
	public get Categoria(): CategoriaModel {
		return this._categoria;
	}

	public set Categoria(value: CategoriaModel) {
		this._categoria = value;
		this._categoriaChange.emit(this._categoria);
	}

	private _marca: MarcaModel = null;
	public _marcaChange: EventEmitter<MarcaModel> = new EventEmitter();
	public get Marca(): MarcaModel {
		return this._marca;
	}

	public set Marca(value: MarcaModel) {
		this._marca = value;
		this._marcaChange.emit(this._marca);
	}

	private _serie: SerieModel = null;
	public _serieChange: EventEmitter<SerieModel> = new EventEmitter();
	public get Serie(): SerieModel {
		return this._serie;
	}

	public set Serie(value: SerieModel) {
		this._serie = value;
		this._serieChange.emit(this._serie);
	}

	private _tipoDeProducto: TipoProductoModel = null;
	public _tipoDeProductoChange: EventEmitter<TipoProductoModel> = new EventEmitter();
	public get TipoDeProducto(): TipoProductoModel {
		return this._tipoDeProducto;
	}

	public set TipoDeProducto(value: TipoProductoModel) {
		this._tipoDeProducto = value;
		this._tipoDeProductoChange.emit(this._tipoDeProducto);
	}

	private _textFilterCategories: Array<MultiCheckboxModel<number>> = null;
	public _textFilterCategoriesChange: EventEmitter<Array<MultiCheckboxModel<number>>> = new EventEmitter();
	public get textFilterCategories(): Array<MultiCheckboxModel<number>> {
		return this._textFilterCategories;
	}

	public set textFilterCategories(value: Array<MultiCheckboxModel<number>>) {
		this._textFilterCategories = value;
		this._textFilterCategoriesChange.emit(this._textFilterCategories);
	}

	TextFilterCategoryDescription: number = 4;

	RegistrosPorPagina: number = 30;
	PaginaActual: number = 1;

	public get ObjetoParaPost() {
		return {
			TextoABuscar: this.TextoABuscar,
			Aplicacion: this.Aplicacion,
			Categoria: this.Categoria,
			IdCategoriaPrincipal: this.CategoriaPrincipal?.Id ?? 0,
			Marca: this.Marca,
			Serie: this.Serie,
			TipoDeProducto: this.TipoDeProducto,
			TextFilterCategories: (this.textFilterCategories ?? new Array<MultiCheckboxModel<number>>()).filter(f => f.checked).map(m => m.key),
			RegistrosPorPagina: this.RegistrosPorPagina,
			PaginaActual: this.PaginaActual
		}
	}

	loadTextFilterCategories(defaultOption: number = null): void {
		const toLoad = new Array<MultiCheckboxModel<number>>();
		
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.category, 'Categoría'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.code, 'Código'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.alternativeCode, 'Código alternativo'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.description, 'Descripción'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.longDescription, 'Descripción larga'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.brand, 'Marca'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.model, 'Modelo'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.productType, 'Tipo de producto'));
		toLoad.push(new MultiCheckboxModel(appConstants.textFilterCategory.serie, 'Serie'));

		if (defaultOption !== null || defaultOption !== undefined) {
			toLoad.forEach((currentMulticheckbox: MultiCheckboxModel<number>) => {
				if (currentMulticheckbox.key === defaultOption)
					currentMulticheckbox.checked = true;
			});
		}

		this.textFilterCategories = toLoad;
	}

}